import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import { TippyV2 } from "@/react/components/shared/TippyV2";
import { Typography } from "@/react/components/shared/uikit/Typography";

export const CircleBotFooterMessage = () => (
  <div className="flex justify-center rounded-lg p-2">
    <Typography.BodyXs color="text-[#A5A9AD]">
      {t("help_widget.conversation_page.copilot_footer_message")}
      <TippyV2
        arrow={false}
        theme="help-widget-tooltip"
        content={t(
          "help_widget.conversation_page.copilot_footer_message_tooltip",
        )}
      >
        <Icon type="info" size={14} useWithFillCurrentColor />
      </TippyV2>
    </Typography.BodyXs>
  </div>
);
